// extracted by mini-css-extract-plugin
export default {"time-from-now":"style_time-from-now__6+2Xh","timeFromNow":"style_time-from-now__6+2Xh"};